/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ContactInfo model module.
 * @module model/ContactInfo
 * @version 1.0.0
 */
class ContactInfo {
    /**
     * Constructs a new <code>ContactInfo</code>.
     * @alias module:model/ContactInfo
     * @param phone {String} 
     */
    constructor(phone) { 
        
        ContactInfo.initialize(this, phone);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, phone) { 
        obj['phone'] = phone;
    }

    /**
     * Constructs a <code>ContactInfo</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ContactInfo} obj Optional instance to populate.
     * @return {module:model/ContactInfo} The populated <code>ContactInfo</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ContactInfo();

            if (data.hasOwnProperty('phone')) {
                obj['phone'] = ApiClient.convertToType(data['phone'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('fax')) {
                obj['fax'] = ApiClient.convertToType(data['fax'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} phone
 */
ContactInfo.prototype['phone'] = undefined;

/**
 * @member {String} email
 */
ContactInfo.prototype['email'] = undefined;

/**
 * @member {String} fax
 */
ContactInfo.prototype['fax'] = undefined;






export default ContactInfo;

